import React from 'react';
import Layout from "../Layout/Layout";
import { elakayAutoText } from "../pageInside/dataElakay";
import SupportChatShell from "../pageInside/SupportChatShell";

const Message = ({ infoSource }) => {
    const pageTexts = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.userMessage || {};
    const chatTexts = pageTexts.supportChat || {};
    const title = pageTexts.t001 || chatTexts.pageTitle || elakayAutoText("support_chat_pageTitle", "Elakay virtual assistant");
    const description = chatTexts.pageDescription || elakayAutoText("support_chat_pageDescription", "Official Elakay virtual assistant");

    return (
        <Layout
            infoSource={infoSource}
            title={title}
            description={description}
            className="container-fluid"
            loading={false}
            SliderPunShow={false}
            {...infoSource?.allSettings?.layout}
        >
            <SupportChatShell infoSource={infoSource} />
        </Layout>
    );
};

export default Message;
